import { Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { EligibilityResult } from "v2/modules/types/intake-funnel";

export function StepHeader({
  disruptionReason,
  eligibilityCheckResult,
}: {
  disruptionReason: "delayed" | "cancelled";
  eligibilityCheckResult?: EligibilityResult;
}) {
  const { t } = useTranslation();

  const bubbleText =
    eligibilityCheckResult === "ineligible"
      ? "steps.disrupted_flight_detected.text"
      : `steps.disrupted_flight_detected.${disruptionReason}.text`;

  return (
    <Box
      as="p"
      borderTopRightRadius="lg"
      borderBottomRightRadius="lg"
      borderBottomLeftRadius="lg"
      backgroundColor="greyscale.300"
      padding={{ base: 4, sm: 8 }}
      fontSize="lg"
      fontWeight="medium"
      lineHeight="base"
      textColor="font-primary"
    >
      {t(bubbleText)}
    </Box>
  );
}
